import throttle from 'lodash/throttle';
import React from 'react';
export default function useThrottle(callback, timeout, leading = true, trailing = true) {
    return React.useCallback(throttle(callback, timeout, {
        leading,
        trailing,
    }), []);
}
